import type { PaginatedListNormalizedResponse, PaginatedListResponse } from '@/types/pagination';

class PaginationService {
  public static normalizePaginatedListResponse<ListItem>(
    res: PaginatedListResponse<ListItem>,
  ): PaginatedListNormalizedResponse<ListItem> {
    const { listings, pagination } = res;

    return {
      dataList: listings,
      pagination: {
        page: pagination.page,
        perPage: pagination.perPage,
        numberOfItems: pagination.numberOfItems,
        isLastPage: pagination.page * pagination.perPage >= pagination.numberOfItems,
      },
    };
  }
}

export default PaginationService;
